<se-po-open-registration-search
  [clearFiltersRequestId]="clearFiltersRequestId"
  [sports]="searchSportOptions"
  [signupTypeList]="searchSignupTypeList"
  [organizations]="searchOrganizations"
  (filtersCleared)="handleFiltersCleared()"
  (searchTermChange)="handleSearchTermChange($event)"
  (filtersChange)="handleFiltersChange($event)"
  (filterAction)="handleFilterAction($event)"></se-po-open-registration-search>

<se-fe-page seFeDataWidth="full" [seFeDataLoaded]="!isLoading">
  <div seFePageContent>
    <section class="open-registration-list">

      @if (!isLoading && !loadError && filteredRegistrationGroups.length) {
        <div class="open-registration-list__organizations">
          @for (organization of filteredRegistrationGroups; track organization.organizationId) {
            <se-fe-card class="open-registration-list__organization-card">
              <se-fe-card-content class="open-registration-list__organization-panel">
                <article
                  class="open-registration-list__organization"
                  [attr.data-org-id]="organization.organizationId">
                  <header class="open-registration-list__header">
                    @if (organization.organizationLogoUrl) {
                      <span class="open-registration-list__logo">
                        <img
                          class="open-registration-list__logo-image"
                          [src]="organization.organizationLogoUrl"
                          [alt]="organization.organizationName + ' logo'"
                          (error)="handleOrganizationLogoError(organization)"/>
                      </span>
                    } @else {
                      <span
                        class="open-registration-list__logo open-registration-list__logo--fallback"
                        [attr.aria-label]="organization.organizationName + ' logo'">
                        <span aria-hidden="true">{{ organizationInitial(organization.organizationName) }}</span>
                      </span>
                    }
                    <h2 class="open-registration-list__org-name">
                      {{ organization.organizationName }}
                    </h2>
                  </header>

                  <ul class="open-registration-list__registrations">
                    @for(registration of organization.registrations; track registration.id){
                      <li class="open-registration-list__registration">
                        <se-open-registration-card
                          [orgName]="organization.organizationName"
                          [orgColor]="organization.organizationColor"
                          [backgroundImgUrl]="organization.organizationLogoUrl"
                          [registrationName]="registration.name"
                          [sport]="registrationSportType(registration)"
                          [type]="registrationSignupTypes(registration)"
                          [buttonLinkUrl]="registration.welcome_url"
                          infoHeaderText="Registration Open"
                          [infoText]="registrationInfoText(registration)"
                          buttonText="Sign up"
                          (primaryActionClick)="handleRegistrationSignupClick()"
                          (shareActionClick)="handleRegistrationShareClick()">
                        </se-open-registration-card>
                      </li>
                    }
                  </ul>
                </article>
              </se-fe-card-content>
            </se-fe-card>
          }
        </div>
        <div class="open-registration-list__scroll-spacer" aria-hidden="true"></div>
      }

      @if(hasLoaded && !isLoading && !loadError && !filteredRegistrationGroups.length){
        <se-fe-card>
          <se-fe-card-content class="open-registration-list__empty">
            <span class="open-registration-list__empty-icon">
              <se-fe-icon seFeDataName="spot_flat_ball" seFeDataSize="950" [seFeDataMargin]="false"></se-fe-icon>
            </span>
            <span class="open-registration-list__empty-text">
              @if (hasActiveSearchCriteria) {
                {{ 'REGISTRATIONS.OPEN_REGISTRATION_FILTERED_EMPTY.message' | translate }}
              } @else {
                {{ 'REGISTRATIONS.OPEN_REGISTRATION_EMPTY.message' | translate }}
              }
            </span>
            @if (hasActiveSearchCriteria) {
              <se-fe-button
                class="open-registration-list__clear-filters-button"
                seFeDataEmphasis="high"
                (click)="handleClearFilters()">
                {{ 'REGISTRATIONS.OPEN_REGISTRATION_FILTERED_EMPTY.clear_filters' | translate }}
              </se-fe-button>
            }
          </se-fe-card-content>
        </se-fe-card>
      }

      @if (loadError) {
        <se-fe-card>
          <se-fe-card-content class="open-registration-list__empty open-registration-list__status--error">
            <se-fe-icon seFeDataName="spot_service_breakdown" seFeDataSize="900" [seFeDataMargin]="false"></se-fe-icon>
            <div class="open-registration-list__empty-text">
              <p>{{ 'REGISTRATIONS.OPEN_REGISTRATION_ERROR.title' | translate }}</p>
              <p>{{ 'REGISTRATIONS.OPEN_REGISTRATION_ERROR.message' | translate }}</p>
            </div>
          </se-fe-card-content>
        </se-fe-card>
      }
    </section>
  </div>
  <se-fe-toast></se-fe-toast>
</se-fe-page>
